// extracted by mini-css-extract-plugin
export default {"orderRow":"order_row_orderRow__gLl4I","image":"order_row_image__Nl+Zm","description":"order_row_description__rWbjo","itemDescription":"order_row_itemDescription__rfkEK"};